// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-body-tertiary {
  --bs-bg-opacity: 1;
  margin-top: 0;
  /* margin-bottom: 10px; */
  padding: 5px;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  background-color: #a38f85 !important;
  animation: fade-in-top 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

@keyframes fade-in-top {
  0% {
    transform: translateY(-50px);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.navbar {
  --bs-navbar-toggler-border-color: var(--color-1);
  --bs-navbar-toggler-border-radius: 4px;
}

/* .navbar .container{
  transition: 0.8s;
}
.navbar .container:hover{
  transition: 0.8s;
  border-radius: 10px;
  box-shadow: 0 0 20PX 3px rgba(0, 0, 0, 0.452);
} */
.nav-logo {
  /* margin: 20px; */
  max-height: 75px;
  cursor: pointer;
  transition: 1.5s;
}

@media (max-width: 767px) {
  .nav-logo {
    /* margin: 5px; */
    max-height: 75px;
  }
}

.nav-logo:hover {
  transition: 0.8s;
  filter: drop-shadow(2px 4px 6px black);
}

.nav-rot {
  position: relative;
  /* animation: rotate 1 1.2s linear; */
}

@keyframes rotate {
  from {
    top: 0px;
    transform: rotate(0deg);
  }

  to {
    top: 50px;
    transform: rotate(360deg);
  }
}

.navbar-toggler-icon {
  color: var(--color-4);
}

.navbar-nav {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  align-items: baseline;
}

.nav-link {
  color: var(--color-4);
  font-size: 24px;
  font-weight: bold;
  /* margin-right: 5rem; */
  transition: 480ms ease-out;
}

@media (max-width: 767px) {
  .nav-link {
    font-size: 20px;
    font-weight: 200;
    margin-right: 0rem;
  }
  .navbar-nav {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    align-items: baseline;
  }
}

.nav-link:hover {
  /* transform: scale(1.1); */
  color: var(--color-2);
  /* transition: transform 380ms ease-in; */
}

.nav-link:focus {
  color: var(--color-2);
}

.nav-link:active {
  color: var(--color-2);
}

:root {
  --color-1: #d8a7a7;
  --color-2: #c4a092;
  --color-3: #d9c1bb;
  --color-4: #fffbf8;
  --color-5: #ad795b;
  --color-6: #a38f84;
  --color-7: #bc9693;
  --color-8: #d4b2a7;
  --color-9: #e7d7c9;
  --color-10: #f7e9e1;
  --color-15: #a38f85;
}

.navbar-toggler {
  background-color: transparent;
  color: transparent;
  outline: none;
  padding: 1px 7px 1px 7px;
  margin: 0;
  width: 25px;
  height: 25px;
}

@media (max-width: 926px) {
  .wide-area-to-tap {
    min-width: 100%;
    text-align: left;
  }
}

span {
  color: #a38f84;
}

.custom-toggle-icon {
  display: block;
  width: 35px;
  height: 3px;
  background-color: var(--color-4);
  margin-bottom: 2px;
  outline: none !important;
  padding: 0;
}

.fixed-navbar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  /* From https://css.glass */
  background: #a38f859e !important;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(6.5px);
  -webkit-backdrop-filter: blur(6.5px);
  /* end  */
  /* box-shadow: 0 0 6px 2px var(--color-1); */
  transition: all 0.5s;
  animation: fade-in-bottom 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

@keyframes fade-in-bottom {
  0% {
    transform: translateY(50px);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (max-width: 767px) {
  .fixed-navbar img {
    width: 40%;
  }
  .navbar .container {
    display: flex;
    /* flex-direction: column; */
    align-items: center;
    gap: 10px;
  }

  .navbar-brand img {
    width: 10pc;
  }

  .fixed-navbar img {
    width: 10pc;
  }
}

@media (max-width: 280px) {
  .fixed-navbar img {
    width: 9pc;
  }

  .navbar-brand img {
    width: 9pc;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Componantes/Navbar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,wBAAmB;EAAnB,mBAAmB;EACnB,oCAAoC;EAEpC,oEAAoE;AACtE;;AAgBA;EACE;IAEE,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IAEE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;;;;;;;GAOG;AACH;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE;IACE,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,gCAAgC;EAChC,yCAAyC;EACzC,4BAA4B;EAC5B,oCAAoC;EACpC,SAAS;EACT,4CAA4C;EAC5C,oBAAoB;EAGpB,uEAAuE;AACzE;;AAgBA;EACE;IAEE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IAEE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EAIA;IACE,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AAhBF;;AAmBA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".bg-body-tertiary {\n  --bs-bg-opacity: 1;\n  margin-top: 0;\n  /* margin-bottom: 10px; */\n  padding: 5px;\n  width: 100%;\n  height: fit-content;\n  background-color: #a38f85 !important;\n  -webkit-animation: fade-in-top 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n  animation: fade-in-top 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n}\n\n@-webkit-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-50px);\n    transform: translateY(-50px);\n    opacity: 0;\n  }\n\n  100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-50px);\n    transform: translateY(-50px);\n    opacity: 0;\n  }\n\n  100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.navbar {\n  --bs-navbar-toggler-border-color: var(--color-1);\n  --bs-navbar-toggler-border-radius: 4px;\n}\n\n/* .navbar .container{\n  transition: 0.8s;\n}\n.navbar .container:hover{\n  transition: 0.8s;\n  border-radius: 10px;\n  box-shadow: 0 0 20PX 3px rgba(0, 0, 0, 0.452);\n} */\n.nav-logo {\n  /* margin: 20px; */\n  max-height: 75px;\n  cursor: pointer;\n  transition: 1.5s;\n}\n\n@media (max-width: 767px) {\n  .nav-logo {\n    /* margin: 5px; */\n    max-height: 75px;\n  }\n}\n\n.nav-logo:hover {\n  transition: 0.8s;\n  filter: drop-shadow(2px 4px 6px black);\n}\n\n.nav-rot {\n  position: relative;\n  /* animation: rotate 1 1.2s linear; */\n}\n\n@keyframes rotate {\n  from {\n    top: 0px;\n    transform: rotate(0deg);\n  }\n\n  to {\n    top: 50px;\n    transform: rotate(360deg);\n  }\n}\n\n.navbar-toggler-icon {\n  color: var(--color-4);\n}\n\n.navbar-nav {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-grow: 1;\n  align-items: baseline;\n}\n\n.nav-link {\n  color: var(--color-4);\n  font-size: 24px;\n  font-weight: bold;\n  /* margin-right: 5rem; */\n  transition: 480ms ease-out;\n}\n\n@media (max-width: 767px) {\n  .nav-link {\n    font-size: 20px;\n    font-weight: 200;\n    margin-right: 0rem;\n  }\n  .navbar-nav {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-grow: 1;\n    align-items: baseline;\n  }\n}\n\n.nav-link:hover {\n  /* transform: scale(1.1); */\n  color: var(--color-2);\n  /* transition: transform 380ms ease-in; */\n}\n\n.nav-link:focus {\n  color: var(--color-2);\n}\n\n.nav-link:active {\n  color: var(--color-2);\n}\n\n:root {\n  --color-1: #d8a7a7;\n  --color-2: #c4a092;\n  --color-3: #d9c1bb;\n  --color-4: #fffbf8;\n  --color-5: #ad795b;\n  --color-6: #a38f84;\n  --color-7: #bc9693;\n  --color-8: #d4b2a7;\n  --color-9: #e7d7c9;\n  --color-10: #f7e9e1;\n  --color-15: #a38f85;\n}\n\n.navbar-toggler {\n  background-color: transparent;\n  color: transparent;\n  outline: none;\n  padding: 1px 7px 1px 7px;\n  margin: 0;\n  width: 25px;\n  height: 25px;\n}\n\n@media (max-width: 926px) {\n  .wide-area-to-tap {\n    min-width: 100%;\n    text-align: left;\n  }\n}\n\nspan {\n  color: #a38f84;\n}\n\n.custom-toggle-icon {\n  display: block;\n  width: 35px;\n  height: 3px;\n  background-color: var(--color-4);\n  margin-bottom: 2px;\n  outline: none !important;\n  padding: 0;\n}\n\n.fixed-navbar {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 1000;\n  /* From https://css.glass */\n  background: #a38f859e !important;\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(6.5px);\n  -webkit-backdrop-filter: blur(6.5px);\n  /* end  */\n  /* box-shadow: 0 0 6px 2px var(--color-1); */\n  transition: all 0.5s;\n  -webkit-animation: fade-in-bottom 0.6s cubic-bezier(0.39, 0.575, 0.565, 1)\n    both;\n  animation: fade-in-bottom 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n}\n\n@-webkit-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(50px);\n    transform: translateY(50px);\n    opacity: 0;\n  }\n\n  100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(50px);\n    transform: translateY(50px);\n    opacity: 0;\n  }\n\n  100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@media (max-width: 767px) {\n  .fixed-navbar img {\n    width: 40%;\n  }\n}\n\n@media (max-width: 767px) {\n  .navbar .container {\n    display: flex;\n    /* flex-direction: column; */\n    align-items: center;\n    gap: 10px;\n  }\n\n  .navbar-brand img {\n    width: 10pc;\n  }\n\n  .fixed-navbar img {\n    width: 10pc;\n  }\n}\n\n@media (max-width: 280px) {\n  .fixed-navbar img {\n    width: 9pc;\n  }\n\n  .navbar-brand img {\n    width: 9pc;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
